"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppProvider = exports.AppContext = void 0;
var react_1 = __importStar(require("react"));
/*
    NOTE: When adding new Default Apps update jest-setup.ts to set the env variable to an
    empty string otherwise when running yarn test -u to update snapshots it will incorrectly pull
    enviroment variables from development enviroments.
*/
var DEFAULT_APPS = [
    {
        name: 'Pipeline Intelligence',
        type: 'PI',
        description: 'Pipeline planning, forecasting, and actionable insights.',
        appUrl: 'https://abm.6sense.com/pipeline_intelligence',
        promoUrl: 'https://6sense.com/platform/pipeline-forecast/',
        hidePromo: true,
    },
    {
        name: 'Sales Intelligence',
        type: 'SI',
        description: 'Sales Intelligence software your team will love.',
        appUrl: ((_b = (_a = window.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.SI_UI_ENDPOINT) || 'https://sales.6sense.com/',
        promoUrl: 'https://6sense.com/platform/sales/',
    },
    {
        name: 'Workflows',
        type: 'WORKFLOWS',
        description: 'Unified canvas for automated data cleansing and omni-channel marketing.',
        appUrl: ((_d = (_c = window.process) === null || _c === void 0 ? void 0 : _c.env) === null || _d === void 0 ? void 0 : _d.WORKFLOWS_UI_ENDPOINT) ? ((_f = (_e = window.process) === null || _e === void 0 ? void 0 : _e.env) === null || _f === void 0 ? void 0 : _f.WORKFLOWS_UI_ENDPOINT) + "workflows-dashboard"
            : 'https://workflows.6sense.com/workflows-dashboard',
        hidePromo: true,
        enabled: true,
    },
    {
        name: 'ABM',
        type: 'ABM',
        hidePromo: true,
        appUrl: ((_h = (_g = window.process) === null || _g === void 0 ? void 0 : _g.env) === null || _h === void 0 ? void 0 : _h.AA_UI_ENDPOINT) || 'https://abm.6sense.com',
    },
    {
        name: 'Conversational Email',
        type: 'CE',
        description: 'Automated lead conversion for modern revenue teams.',
        appUrl: ((_k = (_j = window.process) === null || _j === void 0 ? void 0 : _j.env) === null || _k === void 0 ? void 0 : _k.CE_UI_ENDPOINT) || 'https://conversations.6sense.com',
        promoUrl: 'https://6sense.com/platform/ai-email-assistant/',
    },
];
exports.AppContext = react_1.createContext({ currentApp: 'ABM', apps: DEFAULT_APPS });
var AppProvider = function (_a) {
    var currentApp = _a.currentApp, _b = _a.enabledApps, enabledApps = _b === void 0 ? [] : _b, apps = _a.apps, props = __rest(_a, ["currentApp", "enabledApps", "apps"]);
    var enabledAppsSet = react_1.useMemo(function () { return new Set(enabledApps); }, [enabledApps]);
    var contextValue = react_1.useMemo(function () { return ({
        currentApp: currentApp,
        apps: apps || DEFAULT_APPS.map(function (app) { return (__assign(__assign({}, app), { enabled: enabledAppsSet.has(app.type) })); }),
    }); }, [apps, currentApp, enabledAppsSet]);
    return (react_1.default.createElement(exports.AppContext.Provider, __assign({}, props, { value: contextValue })));
};
exports.AppProvider = AppProvider;
